import { createAsyncReducer } from '../../standard-actions/reducers';
import {
    ILoadMonthlyReportsAction,
    ILoadMonthlyReportsSuccessAction,
    LoadMonthlyReportsErrorAction
} from '../actions/load-monthly-reports';
import { ITPAMSReportsState } from '../state';
import { initialState } from '../state/initial-state';

export type LoadMonthlyReportsAction
    = ILoadMonthlyReportsAction
    | ILoadMonthlyReportsSuccessAction
    | LoadMonthlyReportsErrorAction;

const init = (state: ITPAMSReportsState, action: LoadMonthlyReportsAction) => ({
    ...state,
    monthlyReports: {
        ...state.monthlyReports,
        status: action.status
    }
});

const success = (state: ITPAMSReportsState, action: LoadMonthlyReportsAction) => ({
    ...state,
    monthlyReports: {
        ...initialState.monthlyReports,
        status: action.status,
        data: (action as ILoadMonthlyReportsSuccessAction).data
    }
});

const failure = (state: ITPAMSReportsState, action: LoadMonthlyReportsAction) => ({
    ...state,
    monthlyReports: {
        ...initialState.monthlyReports,
        status: action.status,
        error: (action as LoadMonthlyReportsErrorAction).error
    }
});

export const loadMonthlyReportsReducer = createAsyncReducer(initialState, init, success, failure);
